import React from 'react';

import { ReactComponent as CalendarIcon } from 'assets/images/calendar.svg';
import { ReactComponent as EmailIcon } from 'assets/images/email.svg';
import { ReactComponent as MobileChatIcon } from 'assets/images/mobile-chat.svg';
import { ReactComponent as PlaneIcon } from 'assets/images/plane-flying.svg';
import { ReactComponent as UserProfileIcon } from 'assets/images/user-profile.svg';
import ProfileInfo from 'components/ProfileInfo';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { ProductType } from 'models/enums/productType';
import { Loyalty } from 'services/loyaltiesService';
import { formatISODateToDDMMYYYY } from 'utils/generic';

import { UserData } from '../..';
import { Container, Title } from './styles';

type Props = {
  user: UserData;
  productType: ProductType;
  isInternationalFlight?: boolean;
  loyaltyProgram?: Loyalty;
};

const ProfileData = ({ user, isInternationalFlight, loyaltyProgram, productType }: Props) => {
  const { t } = useStoreTranslation();
  const profileWithFullLoyalty = !!loyaltyProgram?.loyaltyName && !!loyaltyProgram?.loyaltyNumber;
  const profileWithPartialLoyalty = !!loyaltyProgram?.loyaltyName && !loyaltyProgram?.loyaltyNumber;
  const loyaltyFormValue = profileWithFullLoyalty
    ? `${loyaltyProgram?.loyaltyName} - ${loyaltyProgram?.loyaltyNumber}`
    : '';
  return (
    <Container>
      <Title>{t('booking.confirmProfile.profileData.header')}</Title>
      <ProfileInfo
        icon={UserProfileIcon}
        title={t('booking.confirmProfile.profileData.fields.fullName')}
        value={user.name && user.lastName ? `${user.name} ${user.lastName}` : undefined}
      />
      <ProfileInfo icon={EmailIcon} title={t('booking.confirmProfile.profileData.fields.email')} value={user.email} />
      <ProfileInfo
        icon={MobileChatIcon}
        title={t('booking.confirmProfile.profileData.fields.phoneNumber')}
        value={user.phoneNumber}
      />
      <ProfileInfo
        icon={UserProfileIcon}
        title={t('booking.confirmProfile.profileData.fields.gender')}
        value={
          user.gender === 'Male'
            ? t('booking.confirmProfile.profileData.genderValues.male')
            : t('booking.confirmProfile.profileData.genderValues.female')
        }
      />
      <ProfileInfo
        icon={CalendarIcon}
        title={t('booking.confirmProfile.profileData.fields.birthDate')}
        value={
          typeof user?.birthDate === 'string' && user.birthDate.includes('/')
            ? user.birthDate
            : new Date(user?.birthDate || '0001-01-01T00:00:00Z').toISOString() === '0001-01-01T00:00:00Z'
            ? ''
            : formatISODateToDDMMYYYY(user?.birthDate) || ''
        }
      />
      <ProfileInfo
        icon={UserProfileIcon}
        title={t('booking.confirmProfile.profileData.fields.documentNumber')}
        value={user.documentNumber}
      />
      {isInternationalFlight && (
        <ProfileInfo
          icon={UserProfileIcon}
          title={t('booking.confirmProfile.profileData.fields.passportNumber')}
          value={user.passportNumber}
        />
      )}
      {productType === ProductType.Flight && (!!profileWithFullLoyalty || !!profileWithPartialLoyalty) && (
        <ProfileInfo
          icon={PlaneIcon}
          title={t('booking.confirmProfile.profileEdit.loyaltyProgramTitle')}
          value={loyaltyFormValue}
        />
      )}
    </Container>
  );
};

export default ProfileData;
